import http from '@/services/http';
import { approvalCustomerChangesFilters } from '@/config';
import tableHelper from '@/services/tableHelper';

const approvalCuctomerChanges = {
  index(tableFilters, filterStatus, config = {}) {
    const filters = tableHelper.whereFilters(
      filterStatus,
      approvalCustomerChangesFilters
    );
    return http.request({
      method: 'get',
      url: '/samples/edit-requests',
      params: {
        filter: {
          ...tableFilters,
          where: filters,
          include: ['sample'],
        },
      },
      ...config,
    });
  },
  count(filterStatus, config = {}) {
    const where = tableHelper.whereFilters(
      filterStatus,
      approvalCustomerChangesFilters
    );
    return http.request({
      method: 'get',
      url: '/samples/edit-requests/count',
      params: { where },
      ...config,
    });
  },
  acceptSampleEdit(requestId) {
    return http.request({
      method: 'post',
      url: `/samples/${requestId}/edit-requests`,
    });
  },
  refuseSampleEdit(requestId) {
    return http.request({
      method: 'delete',
      url: `/samples/${requestId}/edit-requests`,
    });
  },
};

export default approvalCuctomerChanges;
